import { createBrowserRouter } from 'react-router-dom';
import { AppLayout } from './layouts/AppLayout';
import { AuthLayout } from './layouts/AuthLayout';
import { PublicLayout } from './layouts/PublicLayout';
import { ProtectedRoute, DraftGate } from './components/ProtectedRoute';
import LandingIndex from './pages/Landing/Index';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import Review from './pages/Review/Review';
import Success from './pages/Success/Success';
import Certificate from './pages/Certificate/Certificate';
import Gallery from './pages/Gallery/Gallery';
import MyCollection from './pages/MyCollection/MyCollection';
import NotFound from './pages/NotFound/NotFound';

export const router = createBrowserRouter([
  { path: '/', element: <LandingIndex /> },

  {
    path: '/login',
    element: (
      <AuthLayout>
        <Login />
      </AuthLayout>
    ),
  },

  {
    path: '/register',
    element: (
      <ProtectedRoute>
        <AppLayout>
          <Register />
        </AppLayout>
      </ProtectedRoute>
    ),
  },

  {
    path: '/review',
    element: (
      <ProtectedRoute>
        <DraftGate>
          <AppLayout>
            <Review />
          </AppLayout>
        </DraftGate>
      </ProtectedRoute>
    ),
  },

  {
    path: '/success/:id',
    element: (
      <ProtectedRoute>
        <AppLayout>
          <Success />
        </AppLayout>
      </ProtectedRoute>
    ),
  },

  {
    path: '/c/:id',
    element: (
      <PublicLayout>
        <Certificate />
      </PublicLayout>
    ),
  },

  {
    path: '/gallery',
    element: (
      <PublicLayout>
        <Gallery />
      </PublicLayout>
    ),
  },

  {
    path: '/minha-colecao',
    element: (
      <ProtectedRoute>
        <AppLayout>
          <MyCollection />
        </AppLayout>
      </ProtectedRoute>
    ),
  },

  {
    path: '*',
    element: (
      <PublicLayout>
        <NotFound />
      </PublicLayout>
    ),
  },
]);
